import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from 'src/app/modules/core/service/v2/abstractRepositoryV2';
import {AudioRecordModel} from '../../../api/model/audioRecord.model';



@Injectable({providedIn: 'root'})
export class AudioRecordRepository extends AbstractRepositoryV2<AudioRecordModel>{
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('AudioRecord', serviceElementsFactory, injector);
    }
}
